export interface Player {
  id: number;
  name: string;
  ageGroup: string;
  // All age groups (many-to-many); ageGroup is primary/legacy
  ageGroups?: string[];
  ageGroupId?: number;
  birth: string;
  citizen?: string;
  countryOfBirth?: string;
  gender: string;
  ifaCode?: string;
  mothersName?: string;
  placeOfBirth?: string;
  sportDoctorValidity?: string;
  taj?: string;
  createdAt: string;
  userId?: number;
  parentUserId?: number;
  secondParentUserId?: number;
  isInactive?: boolean;
  inactivatedAt?: string;
  inactiveReason?: string;
  schoolId?: number | null;
  schoolName?: string | null;
  // Elérhetőség és egészségügyi adatok: csak a stáb, a játékos és a szülei kapják meg
  phone?: string | null;
  address?: string | null;
  emergencyContactName?: string | null;
  emergencyContactPhone?: string | null;
  emergencyContactRelation?: string | null;
  medicalNotes?: string | null;
  contactUpdatedAt?: string | null;
  user?: LinkedUserContact | null;
  parentUser?: LinkedUserContact | null;
  secondParentUser?: LinkedUserContact | null;
  /** Ha a játékos ma betegség/sérülés miatt ki van jelentve. */
  currentAbsence?: PlayerAbsenceSummary | null;
}

export interface LinkedUserContact {
  id: number;
  email: string;
  name: string;
  phone?: string | null;
}

/** A backend AbsenceType enum. */
export enum AbsenceType {
  Illness = 1,
  Injury = 2,
  Other = 3,
}

export const ABSENCE_TYPE_LABELS: Record<AbsenceType, string> = {
  [AbsenceType.Illness]: 'Beteg',
  [AbsenceType.Injury]: 'Sérült',
  [AbsenceType.Other]: 'Távol',
};

export interface PlayerAbsenceSummary {
  id: number;
  type: AbsenceType;
  startDate: string;
  endDate: string;
}

export interface PlayerAbsence extends PlayerAbsenceSummary {
  playerId: number;
  playerName: string;
  ageGroup: string;
  note?: string | null;
  createdByUserName: string;
  createdAt: string;
  /** Hány jövőbeli eseményre került emiatt "Nem jön". */
  affectedEventCount: number;
}

export interface SavePlayerAbsenceRequest {
  type: AbsenceType;
  startDate: string;
  endDate: string;
  note?: string;
}

/** Az elérhetőségek teljes cseréje: az üres mező törlődik. */
export interface UpdatePlayerContactRequest {
  phone?: string;
  address?: string;
  emergencyContactName?: string;
  emergencyContactPhone?: string;
  emergencyContactRelation?: string;
  medicalNotes?: string;
}

export interface PlayerImportRow {
  rowNumber: number;
  name: string;
  birth?: string | null;
  gender?: string | null;
  ageGroupId?: number | null;
  ageGroupName?: string | null;
  placeOfBirth?: string | null;
  citizen?: string | null;
  mothersName?: string | null;
  taj?: string | null;
  ifaCode?: string | null;
  sportDoctorValidity?: string | null;
  phone?: string | null;
  address?: string | null;
  emergencyContactName?: string | null;
  emergencyContactPhone?: string | null;
  medicalNotes?: string | null;
  parentEmail?: string | null;
  parentUserId?: number | null;
  parentUserName?: string | null;
  errors: string[];
  warnings: string[];
  isDuplicate: boolean;
}

export interface PlayerImportPreview {
  rows: PlayerImportRow[];
  validCount: number;
  errorCount: number;
  duplicateCount: number;
}

export interface PlayerImportResult {
  createdCount: number;
  skippedCount: number;
  messages: string[];
}

export interface CreatePlayerRequest {
  name: string;
  ageGroup: string;
  ageGroupId?: number;
  birth: string;
  citizen?: string;
  countryOfBirth?: string;
  gender: string;
  ifaCode?: string;
  mothersName?: string;
  placeOfBirth?: string;
  sportDoctorValidity?: string;
  taj?: string;
  userId?: number;
  parentUserId?: number;
  secondParentUserId?: number;
  schoolId?: number;
  phone?: string;
  address?: string;
  emergencyContactName?: string;
  emergencyContactPhone?: string;
  emergencyContactRelation?: string;
  medicalNotes?: string;
}

export interface UpdatePlayerRequest {
  name?: string;
  ageGroup?: string;
  ageGroupId?: number;
  birth?: string;
  citizen?: string;
  countryOfBirth?: string;
  gender?: string;
  ifaCode?: string;
  mothersName?: string;
  placeOfBirth?: string;
  sportDoctorValidity?: string;
  taj?: string;
  userId?: number;
  parentUserId?: number;
  secondParentUserId?: number;
  clearUserId?: boolean;
  clearParentUserId?: boolean;
  clearSecondParentUserId?: boolean;
  schoolId?: number;
  clearSchoolId?: boolean;
  /** Ha meg van adva, az elérhetőségek teljes egészében erre cserélődnek. */
  contact?: UpdatePlayerContactRequest;
}

/** Egy fiók a játékos szerkesztőjének választóiban. */
export interface PlayerAccountOption {
  id: number;
  name: string;
  email: string;
  isPlayer: boolean;
  isParent: boolean;
  isActive: boolean;
}
